import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useMemo } from 'react';
import { useUserProjects } from '../hooks/useUserProjects';
const UserProjectsContext = createContext(undefined);
export const UserProjectsProvider = ({ children }) => {
    // Single source of truth for user projects + polling
    const value = useUserProjects();
    // Memoize to avoid unnecessary re-renders of consumers when identity is stable
    const memoizedValue = useMemo(() => value, [
        value.projects,
        value.isLoading,
        value.error,
        value.hasLoaded
    ]);
    return (_jsx(UserProjectsContext.Provider, { value: memoizedValue, children: children }));
};
export const useUserProjectsContext = () => {
    const ctx = useContext(UserProjectsContext);
    if (!ctx) {
        throw new Error('useUserProjectsContext must be used within a UserProjectsProvider');
    }
    return ctx;
};
